/* KISHI KAISEI — emails cliquables + choix de messagerie (Gmail / Outlook / IONOS) */
(function(){
  'use strict';

  function linkify(root){
    if(!root) return;
    var walker=document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes=[], n;
    while((n=walker.nextNode())){
      if(n.nodeValue && n.nodeValue.indexOf('@')>-1){
        var p=n.parentNode; if(!p) continue;
        var tag=p.nodeName.toLowerCase();
        if(tag==='a'||tag==='script'||tag==='style'||tag==='textarea'||tag==='input'||tag==='option') continue;
        if(/[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}/.test(n.nodeValue)) nodes.push(n);
      }
    }
    for(var i=0;i<nodes.length;i++){ (function(node){
      var text=node.nodeValue, re=/[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}/g, last=0, m, frag=document.createDocumentFragment();
      while((m=re.exec(text))){
        if(m.index>last) frag.appendChild(document.createTextNode(text.slice(last,m.index)));
        var a=document.createElement('a'); a.href='mailto:'+m[0]; a.textContent=m[0]; a.className='kk-mail'; frag.appendChild(a);
        last=m.index+m[0].length;
      }
      if(last<text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      if(node.parentNode) node.parentNode.replaceChild(frag, node);
    })(nodes[i]); }
  }

  function run(){
    linkify(document.getElementById('MainContent'));
    linkify(document.querySelector('footer'));
    var links=document.querySelectorAll('a[href^="mailto:"]');
    for(var i=0;i<links.length;i++){ links[i].classList.add('kk-mail'); }
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', run); } else { run(); }

  function chooser(to, anchor){
    var ex=document.getElementById('kkMailChooser'); if(ex && ex.parentNode) ex.parentNode.removeChild(ex);
    var box=document.createElement('div'); box.id='kkMailChooser'; box.className='kk-mailchooser';
    var t=encodeURIComponent(to);
    box.innerHTML='<div class="kk-mc-title">Écrire à '+to+'</div>'
      +'<a class="kk-mc-opt" href="https://mail.google.com/mail/?view=cm&fs=1&to='+t+'" target="_blank" rel="noopener">Gmail</a>'
      +'<a class="kk-mc-opt" href="https://outlook.live.com/mail/0/deeplink/compose?to='+t+'" target="_blank" rel="noopener">Outlook</a>'
      +'<a class="kk-mc-opt" href="https://mail.ionos.fr/" target="_blank" rel="noopener">IONOS</a>'
      +'<a class="kk-mc-opt kk-mc-def" href="mailto:'+to+'">Autre · appli par défaut</a>';
    document.body.appendChild(box);
    var r=anchor.getBoundingClientRect();
    var top=window.pageYOffset+r.bottom+6, left=window.pageXOffset+r.left;
    box.style.top=top+'px';
    if(left+box.offsetWidth > window.pageXOffset+window.innerWidth-10){ left=window.pageXOffset+window.innerWidth-box.offsetWidth-10; }
    box.style.left=Math.max(10,left)+'px';
    function close(e){ if(box && !box.contains(e.target)){ if(box.parentNode) box.parentNode.removeChild(box); document.removeEventListener('click', close, true); } }
    setTimeout(function(){ document.addEventListener('click', close, true); }, 0);
    box.addEventListener('click', function(e){ var o=e.target.closest('.kk-mc-opt'); if(o){ setTimeout(function(){ if(box.parentNode) box.parentNode.removeChild(box); }, 40); } });
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('.kk-mailchooser')) return;
    var a=e.target.closest('a.kk-mail, a[href^="mailto:"]');
    if(!a) return;
    var href=a.getAttribute('href')||'';
    var to=href.replace(/^mailto:/i,'').split('?')[0].trim();
    if(!to) to=(a.textContent||'').trim();
    if(!to || to.indexOf('@')===-1) return;
    e.preventDefault();
    chooser(to, a);
  });
})();
